import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StringUtilities } from 'src/app/Util/string-utils';
import { ServerDetailsKeyPair } from '../interfaces/server-details-key-pair';
@Component({
  selector: 'app-serverdetailspopup',
  templateUrl: './serverdetailspopup.component.html',
  styleUrls: ['./serverdetailspopup.component.sass']
})

export class ServerdetailspopupComponent implements OnInit {

  @Input() environmentDetails: object;
  environment: ServerDetailsKeyPair[] = [];
  serverName: string = "";

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.environment = Object.entries(this.environmentDetails).map(
      ([key, value]) => ({ key: StringUtilities.formatKey(key), value })
    );
    this.environment = this.environment.filter(env => {
      if(env.value != null) return env
    })
    this.serverName = this.environment[0].value;
  }

}
